const parseAmount = (rawValue, suffix = "") => {
  const value = Number(String(rawValue).replace(/,/g, ""));
  if (!Number.isFinite(value)) return null;
  const multiplier = /^(k|thousand)$/i.test(suffix)
    ? 1_000
    : /^(l|lac|lakh)$/i.test(suffix)
      ? 100_000
      : 1;
  return Math.round(value * multiplier);
};

const AMOUNT = "(?:₹|rs\\.?|inr)?\\s*([0-9]+(?:[.,][0-9]+)?)\\s*(thousand|lakh|lac|k|l)?";

export const parseSearchIntent = (rawQuery) => {
  let query = String(rawQuery || "").trim();
  let min;
  let max;

  const between = new RegExp(`\\b(?:between|from)\\s+${AMOUNT}\\s+(?:and|to|-)\\s+${AMOUNT}`, "i");
  const upper = new RegExp(`\\b(?:under|below|less than|up to|max(?:imum)?(?: of)?)\\s+${AMOUNT}`, "i");
  const lower = new RegExp(`\\b(?:over|above|more than|at least|min(?:imum)?(?: of)?|starting from)\\s+${AMOUNT}`, "i");

  const betweenMatch = query.match(between);
  if (betweenMatch) {
    min = parseAmount(betweenMatch[1], betweenMatch[2]);
    max = parseAmount(betweenMatch[3], betweenMatch[4]);
    if (min > max) [min, max] = [max, min];
    query = query.replace(betweenMatch[0], " ");
  } else {
    const upperMatch = query.match(upper);
    const lowerMatch = query.match(lower);
    if (upperMatch) {
      max = parseAmount(upperMatch[1], upperMatch[2]);
      query = query.replace(upperMatch[0], " ");
    } else if (lowerMatch) {
      min = parseAmount(lowerMatch[1], lowerMatch[2]);
      query = query.replace(lowerMatch[0], " ");
    }
  }

  query = query
    .replace(/^(?:find|search(?:\s+for)?|show me|looking for)\s+/i, "")
    .replace(/\s+/g, " ")
    .trim();

  return { query, price: min != null || max != null ? [min ?? 0, max] : null };
};
